export const SUITE_GROUPS = [];

export const SUITE_PAGES = SUITE_GROUPS.flatMap((g) => g.pages);
